import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Modal, Input, Button, message } from 'antd';
import { getEndDay, checkProv, checkDate } from '../../utils';
import time from '../../imgs/time.png';
import xuliehao from '../../imgs/xuliehao.png';
import card from '../../imgs/card.png';
import name from '../../imgs/name.png';
import { apis } from '../../api/index.js';

const AccountInfo = props => {
  const [nickName, setNickName] = useState('');
  const [certId, setCertId] = useState('');
  useEffect(() => {
    if (props.visible) {
      const { nickName, certId } = props;
      setNickName(nickName);
      setCertId(certId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);

  const userInfoSubmit = () => {
    if (!certId) {
      message.warning('请输入身份证号码');
      return;
    }
    const reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    const province = certId.substring(0, 2);
    const birthday = certId.substring(6, 14);

    const _17Index = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const front17 = certId.slice(0, 17);
    let _18 = certId.slice(17, 18);
    _18 = isNaN(parseInt(_18)) ? _18.toLowerCase() : parseInt(_18);
    let remainder = 0;
    for (let i = 0; i < 17; i++) {
      remainder += parseInt(front17.charAt(i)) * _17Index[i];
    }
    let remainderKeyArr = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
    let remainderKey =
      typeof remainderKeyArr[remainder % 11] === 'string'
        ? 'x'
        : remainderKeyArr[remainder % 11];

    if (!reg.test(certId)) {
      message.warning('身份证号码不合规');
      return;
    } else if (!checkProv(province)) {
      message.warning('身份证号码不合规');
      return;
    } else if (!checkDate(birthday)) {
      message.warning('身份证号码不合规');
      return;
    } else if (remainderKey !== _18) {
      message.warning('身份证号码不合规');
      return;
    }
    if (!nickName || nickName.length > 4) {
      message.warning('请填写您的真实姓名');
      return;
    }
    let { userInfo } = props;
    const post = { certId, id: userInfo.id, nickName };
    apis.modifyBoxUser(post).then(res => {
      if (res.code === '0') {
        message.success('修改成功');
        userInfo = { ...userInfo, ...post };
        props.onUserInfoUpdated(userInfo);
        props.onSetNewState({ certId, nickName });
        props.onCancel();
      } else message.error(res.message);
    });
  };

  const { createTime } = props.userInfo;
  let endTime = '--';
  if (createTime) endTime = getEndDay(createTime, 10 * 365);
  return (
    <Modal
      title="账户信息"
      centered
      visible={props.visible}
      onCancel={props.onCancel}
      destroyOnClose={true}
      width={600}
      className="help-dialog"
      footer={null}
      zIndex={1005}
    >
      <div className="helpBox" style={{ height: '260px' }}>
        <div className="helpContent">
          <div className="helpBody">
            <div>
              <div className="helpItem">
                <img alt="" src={time} />
                <div>账号有效期至：{endTime}</div>
              </div>
              <div className="helpItem">
                <img alt="" src={xuliehao} width={20} />
                <div>序列号：{props.serialNumber || ''}</div>
              </div>
              <div className="helpItem">
                <img alt="" src={card} width={20} />
                <div className="card-item">
                  <span className="card-label">身份证号：</span>
                  <Input
                    onChange={({ target: { value } }) => setCertId(value)}
                    value={certId}
                    allowClear={true}
                  />
                </div>
              </div>
              <div className="helpItem">
                <img alt="" src={name} width={20} />
                <div className="card-item">
                  <span className="card-label">姓名：</span>
                  <Input
                    onChange={({ target: { value } }) => setNickName(value)}
                    value={nickName}
                    allowClear={true}
                  />
                </div>
              </div>
              <div style={{ paddingLeft: '100px' }}>
                <Button type="primary" onClick={userInfoSubmit}>
                  提交
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
AccountInfo.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  certId: PropTypes.string,
  nickName: PropTypes.string,
  serialNumber: PropTypes.string,
  onUserInfoUpdated: PropTypes.func,
  onSetNewState: PropTypes.func,
  userInfo: PropTypes.object,
};
export default AccountInfo;
